import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const TruncatedText = styled('span')(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const Root = styled(Box)(({ theme }) => ({
  cursor: 'default',
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.up('lg')]: {
    gap: '0.375rem'
  }
}));

export const Email = styled(TruncatedText)(() => ({
  fontSize: '0.875rem',
  lineHeight: '1.25rem'
}));
